const AUTH_TOKEN_KEY = "assistant_auth_token";
const SESSION_ID_KEY = "assistant_session_id";

export function getAuthToken(): string | null {
  if (typeof window === "undefined") return null;
  return localStorage.getItem(AUTH_TOKEN_KEY);
}

export function setAuthToken(token: string) {
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearAuthToken() {
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function getSessionId(): string | null {
  if (typeof window === "undefined") return null;
  return sessionStorage.getItem(SESSION_ID_KEY);
}

export function setSessionId(sessionId: string) {
  sessionStorage.setItem(SESSION_ID_KEY, sessionId);
}

export function clearSessionId() {
  sessionStorage.removeItem(SESSION_ID_KEY);
}
